import tw, { styled } from 'twin.macro';

export const StyledSpacer = styled.div`
  ${tw`my-3`}
`;

export const StyledAudioPlayer = styled.div`
  ${tw`my-3`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`w-full`}
  ${tw`p-3`}
  ${tw`flex`}
  ${tw`items-center`}
  ${tw`rounded-xl`}
  ${tw`gap-2`}
  ${tw`shadow`}
`;

export const StyledButton = styled.button`
  ${tw`cursor-pointer`}
  ${tw`text-primary-p1`}
`;

export const StyledSlider = styled.input`
  ${tw`flex-1`}
  ${tw`cursor-pointer`}
  accent-color: #290042;
`;
